import { ConditionalWrap } from '~/common/components/ConditionalWrap/ConditionalWrap';

import { MarkedText } from './MarkedText';

type Props = {
  text: string;
  search?: string;
};

/** Renders `text` plain, or with `search` matches highlighted via `MarkedText` when a search term is active. */
export const HighlightableText = ({ text, search }: Props) => (
  <ConditionalWrap
    condition={!!search}
    wrapper={() => <MarkedText text={text} search={search} />}
  >
    {text}
  </ConditionalWrap>
);
